import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { Collapse } from 'react-bootstrap'
import { Row, Col } from 'react-flexbox-grid'

import NameFilter from './filters/name_filter_sim_golf'
import SeasonFilterSimGolf from './filters/season_filter_sim_golf'
import CategoryFilterSimGolf from './filters/category_filter_sim_golf'
import AdvancedFiltersSimGolf from './filters/advanced_filters_sim_golf'
import RegistrationFilterSimGolf from './filters/registration_filter_sim_golf'

const CategoriesFiltersSimGolfComponent = (
  {
    seasonsOptions,
    showSeasons,
    categoriesOptions,
    showCategoryFilter,
    leagueName,
    advancedFiltersOn,
    selectedSeason,
    selectedCategory,
    selectedRegistration,
    showRegistrationOptions,
    changeFilter,
    dataIsLoading,
    loadingFilters,
    categories,
    setListView,
    setCalendarView,
    setIsChecked,
    viewType,
  }) => {
  let numberOfEvents = 0
  if (selectedCategory == 'all')
    numberOfEvents = _.sumBy(Object.values(categories), category => category.leaguesCount)
  else
    numberOfEvents = _.sumBy(Object.keys(categories).map(key => key == selectedCategory && categories[key].leaguesCount))

  return (
    <div className='categories_filters_sim_golf'>
      <span className='custom_filters_sim_golf'>
        <NameFilter
          value={ leagueName }
          onChange={ changeFilter }
          loadingFilters={ loadingFilters }
        />
        <AdvancedFiltersSimGolf
          open={ advancedFiltersOn }
          onChange={ changeFilter }
          disabled={ dataIsLoading }
          eventsFound={ numberOfEvents }
          setListView={ setListView }
          setCalendarView ={ setCalendarView }
          setIsChecked={ setIsChecked }
          viewType={ viewType }
        />
      </span>
      <Collapse in={ advancedFiltersOn }>
          <div className='transition-wrapper'>
            <Row>
              { showSeasons && (
                <Col xs={ 12 } sm={ 6 } md={ 6 } lg={ true } className='no-lite'>
                  <SeasonFilterSimGolf
                    seasonsOptions={ seasonsOptions }
                    value={ selectedSeason }
                    onChange={ changeFilter }
                  />
                </Col>
              )}
              { ( showCategoryFilter || dataIsLoading ) && (
                <Col xs={ 12 } sm={ 6 } md={ 6 } lg={ true } className='no-lite'>
                  <CategoryFilterSimGolf
                    categoriesOptions={ categoriesOptions }
                    value={ selectedCategory }
                    onChange={ changeFilter }
                    disabled={ dataIsLoading }
                  />
                </Col>
              )}
              <Col xs={ 12 } sm={ 6 } md={ 6 } lg={ true } className='no-lite'>
                <RegistrationFilterSimGolf
                  value={ selectedRegistration }
                  onChange={ changeFilter }
                  disabled={ dataIsLoading }
                  showRegistrationOptions={ showRegistrationOptions }
                />
              </Col>
            </Row>
          </div>
        </Collapse>
    </div>
  )
}

CategoriesFiltersSimGolfComponent.propTypes = {
  seasonsOptions: PropTypes.array.isRequired,
  showSeasons: PropTypes.bool.isRequired,
  categoriesOptions: PropTypes.array.isRequired,
  showCategoryFilter: PropTypes.bool.isRequired,
  advancedFiltersOn: PropTypes.bool.isRequired,
  selectedSeason: PropTypes.string.isRequired,
  selectedCategory: PropTypes.string.isRequired,
  selectedRegistration: PropTypes.string.isRequired,
  showRegistrationOptions: PropTypes.bool.isRequired,
  changeFilter: PropTypes.func.isRequired,
  dataIsLoading: PropTypes.bool.isRequired,
  setListView: PropTypes.func.isRequired,
  setCalendarView: PropTypes.func.isRequired,
  setIsChecked: PropTypes.func.isRequired,
  viewType: PropTypes.string.isRequired,
  loadingFilters: PropTypes.bool,
  categories: PropTypes.object,
  leagueName: PropTypes.string,
}

export default CategoriesFiltersSimGolfComponent